// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"gY-z","sponsoredTooltipWrapper":"hY-z","sponsoredTooltip":"iY-z","newCard":"jY-z"};